import { render, staticRenderFns } from "./CorrespondenceLetterUpdate.vue?vue&type=template&id=2858a826"
import script from "./CorrespondenceLetterUpdate.vue?vue&type=script&lang=js"
export * from "./CorrespondenceLetterUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports